import { OrderPriceRange } from '__generated__/atlas-types'

import { formatCurrencyPriceRangeStr } from '../../ProductsWidget/formatters'
import { FinancialSummaryTestIds } from '../FinancialSummaryWidget'
import { ConceptText, NumericText, Row } from '../FinancialSummaryWidget.ui'

const TotalDue = ({
  currencyCode,
  dueTotal = { maxPrice: '0', minPrice: '0' },
}: {
  currencyCode: string
  dueTotal?: OrderPriceRange
}) => {
  return (
    <Row className="total">
      <ConceptText>Total Due</ConceptText>
      <NumericText id={FinancialSummaryTestIds.TaxNumber}>
        {formatCurrencyPriceRangeStr(currencyCode, dueTotal)}
      </NumericText>
    </Row>
  )
}

export default TotalDue
